import { useEffect } from 'react';
import userflow from 'userflow.js';
import { MOBILE_BREAKPOINT } from 'App/constants/breakpoints';
import { useStorage } from 'commons/hooks';
import useWindowSize from 'commons/hooks/useWindowSize';
import { useGetPlan, useGetUserInfo } from 'domains/Auth/hooks';
import { useStoreInfo } from 'domains/PartnersApps/hooks';
import { config } from './config';

function Userflow(): null {
  const { email, id, isMain, name } = useGetUserInfo();
  const { width } = useWindowSize();

  const {
    id: storeId,
    country: countryCode,
    url: storeUrl,
    createdAt,
    currentSegment,
    currentTheme,
    name: storeName,
  } = useStoreInfo();
  const { niceName } = useGetPlan();
  const localStorageItem = `pre-onboarding-questionnaire-completed-${storeId}`;
  const [questionnaireCompleted, _, loaded] = useStorage(
    localStorageItem,
    false,
  );

  useEffect(() => {
    if (!config.id) return;

    userflow.init(config.id);
    userflow.identify(email, {
      userId: id,
      email,
      isMain,
      name,
      countryCode,
      deviceType: width <= MOBILE_BREAKPOINT ? 'mobile' : 'desktop',
    });
    userflow.group(storeId, {
      name: storeName,
      storeId,
      storeUrl,
      countryCode,
      statusByOrder: currentSegment,
      storePlan: niceName,
      signUpAt: createdAt,
      activeTheme: currentTheme,
      preOnboardingCompleted: loaded ? questionnaireCompleted : false,
    });
  }, [
    email,
    storeId,
    createdAt,
    niceName,
    storeUrl,
    currentSegment,
    countryCode,
    id,
    isMain,
    name,
    questionnaireCompleted,
    loaded,
    currentTheme,
    storeName,
    width,
  ]);

  return null;
}

export default Userflow;
